import CartDetails from "components/Cart";

const Cart = () => {
  return <CartDetails />;
};

export default Cart;
